<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Login form</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="username"
                    name="login"
                    label="Login"
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    id="password"
                    prepend-icon="lock"
                    name="password"
                    label="Password"
                    type="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="login()" color="primary">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      username: "",
      password: "",
    };
  },
  created() {
     console.log(this.$store.getters.isAuthenticated);
  },
  methods: {
    login() {
      let self = this;
      let formData = new FormData();
      formData.append("username", this.username);
      formData.append("password", this.password);
      axios
        .post(process.env.VUE_APP_URL_API + "login", formData)
        .then((response) => {
          let data = response.data;
          self.$store.dispatch("setLoginData", data);
          self.$router.go({name : "Setting"})
        });
    },
  },
  name: "Login",
  props: {
    source: String,
  },
};
</script>

<style></style>
